export enum DoubleOptInRoutes {
  root = 'settings/double-opt-in',
}
